import React from 'react';
import { useMutation, useNotify, Button } from 'react-admin';
import BarChartIcon from '@material-ui/icons/BarChart';

export const ScheduledReportButton = ({ params }) => {
  const record = params.record;
  const endPoint = params.end_point;
  const buttonLabelPrivate =  params.button_label || 'Send Report(s) Now';
	let notify = useNotify();
	let [crawl, { loading }] = useMutation({
		type: 'getOne',
		resource: endPoint + '&x=', // '/run_report?pubid=' + record.code + '&x='
		payload: {}
	},
		{
			onSuccess: ({ data }) => {
				notify('We sent the report. If you don\'t receive the report by email check your parameters.', 'info', {}, false);
				loading = false
			},
			onFailure: (error) => {
				console.log("ERROR", error);
				notify(`Scheduled report error: ${error.message}`, 'warning')
				loading = false
			}
		}
	);
	if (record.report_schedule_config && record.report_schedule_config.length > 0) {
		return <Button label={`${buttonLabelPrivate}`} onClick={crawl} disabled={loading} startIcon={<BarChartIcon />} variant="contained" color="primary" />;
	} else {
		return <span></span>
	}
};